import { CHART_COLORS } from "../../../../utils/constants/ChartUtils.constants";

function PieChartConfig(title, label, statistikResult) {
  const config = {
    type: "pie",
    data: {
      labels: statistikResult.labels,
      datasets: [
        {
          label: label,
          data: statistikResult.data,
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
        },
        title: {
          display: true,
          color: "black",
          text: title,
          align: "center",
          font: {
            weight: "bold",
            size: 21,
            family: "Open Sans",
          },
          padding: {
            top: 10,
            bottom: 30,
          },
        },
      },
    },
  };

  if (statistikResult.data.every((value) => value === 0)) {
    config.data.labels = ["Tidak ada data"];
    config.data.datasets[0].label = "No Data";
    config.data.datasets[0].data = [1];
    config.data.datasets[0].backgroundColor = CHART_COLORS.grey;
  }

  return config;
}

export default PieChartConfig;
